import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal} from '@sabre/spark-react'
import messageIcon from "../../utils/messageIcon"


export default class SimpleMessage extends Component {
    onOK = () => {
        this.props.actions.onMessageOK()
    }

    onCancel = () => {
        this.props.actions.onClose()
    }

    render() {
        const okCaption = this.props.okCaption || 'OK'
        const cancelCaption = this.props.cancelCaption || 'Cancel'
        const isCancelVisible = this.props.isCancelVisible !== undefined ? this.props.isCancelVisible : true

        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onCancel}>
                <div
                    className={`spark-message spark-message--lg spark-message--${this.props.type} spark-margin-bottom`}>
                    <i className={`spark-message__icon ${messageIcon(this.props.type)} spark-icon--fill`}/>
                    <div className="spark-message__content">
                        <h4 className="spark-message__heading">{this.props.title}</h4>
                        <p>{this.props.text}</p>
                    </div>
                </div>
                <nav className="spark-btn-group">
                    {isCancelVisible && <Button onClick={this.onCancel}>{cancelCaption}</Button>}
                    <Button className="focus" onClick={this.onOK}>{okCaption}</Button>
                </nav>
            </Modal>
        )
    }
}

SimpleMessage.propTypes = {
    actions: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['error', 'warning', 'success', 'info']),
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    okCaption: PropTypes.string,
    cancelCaption: PropTypes.string,
    isCancelVisible: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/shared/components/SimpleMessage/index.js